<template>
    <div>
        <Heading
            ecommerce
            title="Add Your Shop to the Platform"
            description='Paste the link of your shop and click "Next"'
        />
        <label 
            id="add-shop-link" 
            class="mt-3" 
            :class="{
                'error': errors['wrong-shop-url-format'] || errors['shop-url-not-found'],
                'valid-shop': isValidShop
            }">
            <span class="c6 mb-2 d-block ml-2">Link</span>
            <div class="input-holder d-flex">
                <Icon icon="link" />
                <input 
                    @keyup.enter="validateFields"
                    v-model = "url"
                    type="text" 
                    placeholder="Your Domain name" 
                    class="w-100 p2n c6">  
            </div>
            <p class="error-text mt-2 pl-1">
                <span v-if="errors['wrong-shop-url-format']">Please input a valid format URL</span>
                <span v-else-if="errors['shop-url-not-found']">Shop url not found</span>
                <span v-else-if="errors['find-shop-internal-error']">Something went wrong</span>
                <span v-else-if="errors['existing-shop']">This shop is already registered</span>
            </p>
            <p class="mt-2 pl-1" v-if="loading">Loading...</p>
        </label>
    </div>
        
</template>
<script>
import Heading from '../../../components/Theme/Heading'
import Icon from '../../../components/Theme/Icon'
import {validationUtils, shopUtils} from '../../../core/utils'
import {ShopsService} from '../../../core/services'
import {useErrors} from '../../../core/hooks'
import {ref, watch} from '@vue/composition-api'

export default {
    name: 'Step1',
    components: {
        Heading,
        Icon
    },
    props: {
        data: Object,
        error: String
    },
    setup(props, {emit, root}){
        const errorHandler = useErrors();

        const errors = useErrors().messages;

        const url = ref(props.data && props.data.domain || '')

        const isValidShop = ref(false)
        const loading = ref(false)

        const validateFields = async () => {

            errorHandler.resetErrors()
            emit('setData', null)

            if(!url.value) return

            isValidShop.value = false

            if(!validationUtils.isValidUrl(url.value)){
                return errorHandler.setError('wrong-shop-url-format', true)
            }

            // check for an already existing shop
            const hostName = shopUtils.handleShopUrl(url.value)

            if(!hostName){
                return errorHandler.setError('wrong-shop-url-format', true)
            }

            const existingShop = await ShopsService.getByUrl(hostName)

            if(existingShop){
                return errorHandler.setError('existing-shop', true)
            }

            loading.value = true

            const response = await ShopsService.find(hostName)

            loading.value = false

            if(response.error) {
                return errorHandler.setError('find-shop-internal-error', true)
            }

            errorHandler.setError('shop-url-not-found', !response.data.id)

            if(response.data.id) {
                isValidShop.value = true
                emit('setData', {...response.data})
                root.$sendMixpanelEvent('Shop Found By Url', {
                    Shop: response.data.title,
                    Domain: response.data.domain
                })
                root.$ga.event('Add Shop', 'Shop Found By Url', `
                    Shop: ${response.data.title},
                    Domain: ${response.data.domain}
                `)
            }
            
        }


        watch(url, newVal => {
            validateFields()
        })

        return {
            url,
            errors,
            isValidShop,
            loading,
            validateFields
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables';

#add-shop-link {
    width: 100%;

    
    .input-holder {
        padding: 18px;
        border: 1px solid #CBD5E0;
        width: 100%;
        border-radius: 4px;
        &:focus {
            border: 1px solid #CBD5E0;
        }

        img {
            margin-right: 18px;
        }

        input {
            border: none;
            border-radius: 4px;
        }
    }


    &.error {
        .input-holder {
            border-color: $c5o7;
            box-shadow: 0 0 4px 0 $c5o7;
        }
    }

    &.valid-shop {
        .input-holder {
            border-color: $c2;
            box-shadow: 0 0 4px 0 $c2;
        }
    }
}
</style>